import { Request } from '../../httpClient/serverApi/requests/Request';
import { IScheduleFrequency } from '../../schedule/types/ISchedule';

export const UpdateScheduleFrequencyServerSettingNames = {
  activeDirectorySyncScheduleFrequency: 'activeDirectorySyncScheduleFrequency',
  recommendationsTrainerScheduleFrequency: 'recommendationsTrainerScheduleFrequency'
};

export interface IUpdateScheduleFrequencyServerSettingParams {
  setting: string;
  value: IScheduleFrequency;
}

export interface IUpdateScheduleFrequencyServerSettingResult {
}

export class UpdateScheduleFrequencyServerSettingRequest extends Request<IUpdateScheduleFrequencyServerSettingParams, IUpdateScheduleFrequencyServerSettingResult> {
  constructor(params: IUpdateScheduleFrequencyServerSettingParams) {
    super('updateScheduleFrequencyServerSetting', params);
  }
}
